var map = {
	"./accounts/accounts-routes.js": "6747",
	"./administrator/administrator-routes.js": "36d5",
	"./application-status/application-status-routes.js": "d45e",
	"./application-type/application-type-routes.js": "25b3",
	"./applications/applications-routes.js": "97cc",
	"./archive/archive-routes.js": "0536",
	"./atlas/atlas-routes.js": "a469",
	"./auth/auth-routes.js": "0c59",
	"./beneficiaries/beneficiaries-routes.js": "7967",
	"./complain-type/complain-type-routes.js": "99b7",
	"./complain/complain-routes.js": "d673",
	"./control-type/control-type-routes.js": "e72d",
	"./control/control-routes.js": "57e1",
	"./dashboard/dashboard-routes.js": "f42d",
	"./decision-purpose/decision-purpose-routes.js": "dd28",
	"./decision-target/decision-target-routes.js": "ef2d",
	"./document-series-allocation/document-series-allocation-routes.js": "488d",
	"./document-series-type/document-series-type-routes.js": "a487",
	"./document-template/document-template-routes.js": "634a",
	"./forms/forms-routes.js": "86da",
	"./home/home-routes.js": "932c",
	"./internal-documents/internal-documents-routes.js": "11e2",
	"./issued-document/issued-document-routes.js": "4c1c",
	"./layout/layout-routes.js": "4007",
	"./metadata-mapping/metadata-mapping-routes.js": "c362",
	"./notifications/notifications-routes.js": "c37f",
	"./payment-registry/payment-registry-routes.js": "68a9",
	"./permissions/permissions-routes.js": "9cb4",
	"./process-editor/process-editor-routes.js": "69eb",
	"./profile/profile-routes.js": "b3b9",
	"./response-templates/response-templates-routes.js": "f6a6",
	"./responsibilities/responsibilities-routes.js": "cca4",
	"./system-settings/system-settings-routes.js": "fdb9",
	"./tax-category/tax-category-routes.js": "1860",
	"./useful-links/useful-links-routes.js": "787a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "00cf";